import { invert } from "lodash";
import Generator from "./devices/Generator";
import Inverter from "./devices/Inverter";
import Module from "./devices/Module";

import Mounting from "../classes/devices/Mounting";
import globalFunctions from "../functions/globalFunctions"
var debug = true;
class SolarPlant {
    area= 0;
    availableDevices={        
        generators: [],
        inverters : [],
        modules : [],
        accessories : [],
        stringboxes : [],
        cables : [],
        connectors : [],
        rails : [],
        transformers: [],
    };
    messages = [];
    inverters = [];
    generators= [];
    acVoltage = 220;
    acPower = 0;
    phases = 3;
    nInverters = 0;
    nModules = 0;
    modules = [];
    mppts = [];
    nMax = 0;
    dcPower = 0;
    dcMaxPower = 0;
    dcMinPower = 0;
    config = [];
    nMin = 0;
    city = {};
    efficiency = 77;//percentage
    production = {
        average: 0,
        months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29]
    }
    structure = {};
    accessories = [];
    stringboxes = [];
    cables = [];
    connectors = [];
    rails = [];
    transformers= [];
    mountings=[
    ];
    newAverageBilling={};

    clone(object){
        // var self = this;
        // self = Object.assign(self, object);
        // this = self;
        Object.assign(this, object );
       //alert(JSON.stringify(this))
        //Clone objects - inverters, modules, generators
        var a ;
        this.inverters = [];
    
        if(object.inverters){
            for(a = 0; a< object.inverters.length ; a++){
                //alert(JSON.stringify(object.inverters[a]))
                var obj = new Inverter();
                obj.clone (object.inverters[a]);
                //alert(JSON.stringify(obj))
                this.inverters.push(obj)
            }
        }
        this.modules = [];
        if(object.modules){
            for(a = 0; a< object.modules.length ; a++){
                var obj = new Module();
                obj.clone (object.modules[a]);
                this.modules.push(obj)
            }
        }

        if(object.generators){
        this.generators = [];
            for(a = 0; a< object.generators.length ; a++){
                var obj = new Generator();
                obj.clone (object.generators[a]);
                this.generators.push(obj)
            }
        }
        if(object.mountings){
            this.mountings = [];
                for(a = 0; a< object.mountings.length ; a++){
                    var obj = new Mounting();
                    obj.clone (object.mountings[a]);
                    this.mountings.push(obj)
                }
            }

        
    
        
        
    };

    constructor(inverters, acVoltage, phases, module,generators) {
        this.acVoltage = acVoltage;
        this.phases = phases;
        this.nMin = 0;
        this.nMax = 0;
        this.nModules = 0;
        var a = 0;

        if(inverters){
            while (a < inverters.length) {
                var inverter = new Inverter();
                inverter = Object.assign(inverter,inverters[a])
                if (!inverter.quantity)
                    inverter.quantity = 1;

                var found = false;
                for (var b = 0; b < this.inverters.length; b++) {
                    if (inverter.code == this.inverters[b].code) {
                        this.inverters[b].quantity += inverter.quantity;
                        this.acPower += inverter.acPower;
                        this.nInverters += inverter.quantity;
                        found = true;
                    }
                }
                if (found == false) {
                    this.inverters.push(inverter);
                    this.acPower += inverter.acPower;
                    this.nInverters += inverter.quantity;
                }
                this.nMin += inverter.nMin * inverter.quantity;
                this.nMax += inverter.nMax * inverter.quantity;

                this.dcMaxPower += inverter.dcMaxPower * inverter.quantity;
                this.dcMinPower += inverter.dcMinPower * inverter.quantity;
                a++;
            };
        }
        
        this.dcPower = 0;
        if(generators){
            this.nModules = 0 ;
            for(a = 0; a < generators.length; a++){
                
                var generator  =  new Generator();
                generator = Object.assign(generator, generators[a])

                if (!generator.quantity)
                    generator.quantity = 1;

                this.generators.push(generator);
                this.dcPower += generators[a].dcPower * generator.quantity;           
                //this.nModules += generators[a].nModules;
                
                if( generators[a].modules.length>0){
                    this.nModules += generators[a].modules[0].quantity;
                }
            }
        }
       
    };
    addInverter(i) {
        var inverter = new Inverter();
        inverter = Object.assign(inverter,i)

        if (!inverter.quantity)
            inverter.quantity = 1;

        var found = false;

        for (var b = 0; b < this.inverters.length; b++) {
            if (inverter.code == this.inverters[b].code) {
                this.inverters[b].quantity += inverter.quantity;
                this.acPower += inverter.acPower;
                this.nInverters += inverter.quantity;
                found = true;
            }
        }
        if (found == false) {
            this.inverters.push(inverter);
            this.acPower += inverter.acPower;
            this.nInverters += inverter.quantity;
        }
        this.nMin += inverter.nMin * inverter.quantity;
        this.nMax += inverter.nMax * inverter.quantity;
        this.dcMaxPower += inverter.dcMaxPower * inverter.quantity;
        this.dcMinPower += inverter.dcMinPower * inverter.quantity;
    };

    calcNewAverageBilling(site) {
        var billing ={
          description:"Energia ativa",
          factor:1,
          minAmount:100,
          price:0,
          quantity:0,
          total:0,
          type:"B2",
          unit:"kWh"
        };

        if(!this.production){
          return billing
        }
        billing = Object.assign({},site.electricalProps.averageBilling);
        var consumption = site.electricalProps.averageBilling.quantity;
        var minAmount = site.electricalProps.averageBilling.minAmount;
        var production = this.production.average ;
        var newConsumption = 0;
        var credits = 0;

        if(consumption - production < minAmount){
          newConsumption = minAmount;
          credits = production - (consumption - minAmount);
        }
          
        if(consumption - production > minAmount){
          newConsumption = consumption - production;
          credits = 0;
        }

        billing.quantity = newConsumption; 
        billing.total = billing.quantity * billing.price;
        billing.credits = credits;
        billing.savings =  site.electricalProps.averageBilling.total -   billing.total ;
        billing.savingsPercentage = 100* billing.savings / site.electricalProps.averageBilling.total ;
        
        this.newAverageBilling = billing;
    };
    
    calcConfig(nModulesRequest) {
        console.log("calcConfig")
        //n = number of - nModulesRequest
        var n = nModulesRequest;
        var mppts = [];
        for (var a = 0; a < this.mppts.length; a++) {
            mppts.push(this.mppts[a])
        }
        var nMpptMax = 0;
        var nMpptMin = 0;
        console.log(JSON.stringify(mppts))
        var positionMax = mppts.length - 1;
        //Considerando que está ordenado, a princípio está pelo método de criação
        //Cria um vetor com a soma dos máximos valores de qtd de módulos de cada mppt
        for (a = 0; a < mppts.length; a++) {
            nMpptMax += mppts[a][mppts[a].length - 1].n;
            nMpptMin += mppts[a][0].n;
        }
        if (debug) console.log({ nMpptMax })
        if (debug) console.log({ nMpptMin })
        if (n < nMpptMin) {
            n = nMpptMin;
        }
        if (this.nInverters >= 5) {
            this.nModules = nModulesRequest;
            this.dcPower = this.nModules * this.modules[0].dcPower;
            this.modules[0].quantity = nModules;
            console.log("No config calculation")
            return;
        }
        var result = false;
        while (!result) {
            this.config = [];
            if ((n > nMpptMax) || (n < nMpptMin))
                return { configs: [], n: 0 };
            result = this.iterar(mppts, n, 0);
            if (!result) {
                n++;
            }
        }
        var nModules = 0;

        for (a = 0; a < this.config.length; a++) {
            nModules += this.config[a].n;
        }
        if (debug) console.log("myConfig:" + JSON.stringify(this.config));
        if (debug) console.log("n final:" + nModules);
        this.nModules = nModules;
        this.modules[0].quantity = nModules;
        this.dcPower = Math.round(this.nModules * this.modules[0].dcPower * 100) / 100;


    };


    iterar(mppts, n, aPos) {
        var mppts_ = [];
        for (var a = 0; a < mppts.length; a++) {
            mppts_.push(mppts[a])
        }
        if (mppts_.length > 1) {
            var mppt = mppts_.shift();
            for (a = 0; a < mppt.length; a++) {
                var n2 = n - mppt[a].n;
                if (n2 == 0) {
                    this.config.unshift({ n: mppt[a].n, mppt: mppt[a], pos: a })
                    return true;
                }
                var response = this.iterar(mppts_, n2, aPos + 1);
                if (response) {
                    this.config.unshift({ n: mppt[a].n, mppt: mppt[a], pos: a })
                    return true;
                }
            }
            //Continuar iteracao
        } else {
            mppt = mppts_[0];
            for (a = 0; a < mppt.length; a++) {
                if (n == mppt[a].n) {
                    this.config.unshift({ n: mppt[a].n, mppt: mppt[a], pos: a })
                    return true;
                }
            }
            return false;
        }
    };

    calc(module) {
        if (debug) console.log("%c concatMppts", "color:green");
        if (debug) console.log("%c number of inverters:" + this.inverters.length, "color:green");
        this.modules = [module];
        var mppts = [];
        var nMax = 0;
        var inverter = {};


        for (var i = 0; i < this.inverters.length; i++) {
            inverter = this.inverters[i];
            inverter.addDcWiring(module);

            console.log("i:" + i)

            console.log("number of mppts:" + inverter.mppts.length)

            for (var indexMppt = 0; indexMppt < inverter.mppts.length; indexMppt++) {
                var mppt = [];
                for (var s = 1; s <= inverter.dcWiring.mppts[indexMppt].limits.sMax; s++) {
                    for (var m = inverter.dcWiring.mppts[indexMppt].limits.mMin; m <= inverter.dcWiring.mppts[indexMppt].limits.mMax; m++) {
                        mppt.push({ n: s * m, s: s, m: m, inverter: inverter.code, indexMppt: i })
                    }
                }
                nMax += inverter.dcWiring.mppts[indexMppt].limits.mMax * inverter.dcWiring.mppts[indexMppt].limits.sMax * inverter.quantity;

                for (var q = 0; q < inverter.quantity; q++) {
                    var newMppt = [];
                    for (var a = 0; a < mppt.length; a++) {
                        var m0 = Object.assign({}, mppt[a]);
                        m0.indexinverter = q;
                        m0.indexList = i;
                        newMppt.push(m0);
                    }
                    mppts.push(newMppt);
                }
            }
            console.log("i after:" + i)
        }
        this.nMax = nMax;
        this.dcMaxPower = Math.round(nMax * module.dcPower * 100) / 100;
        this.mppts = mppts;


    };

    calcProduction(site) {
        var a = 0;

        if(site){
            this.site = site;
        };

        if (!this.city)
            return false
        
        if (this.modules.length == 0 ){
            for (a = 0; a < this.city.yield.months.length; a++) {
                this.production.months[a] = Math.round(100 * this.city.yield.months[a] * (this.dcPower * this.efficiency / 100) ) / 100;
            }
            this.production.average = Math.round(100 * this.city.yield.average * this.dcPower * (this.efficiency / 100) ) / 100;
            for (a = 0; a < 50; a++) {
                this.production.years[a] = Math.round(100 * this.city.yield.average * (this.dcPower * this.efficiency / 100)  * 12) / 100;
            }
           this.calcNewAverageBilling(this.site)
            return true;
        }


        for (a = 0; a < this.city.yield.months.length; a++) {
            this.production.months[a] = Math.round(100 * this.city.yield.months[a] * (this.dcPower * this.efficiency / 100) * (this.modules[0].performanceOverYears[0] / 100)) / 100;
        }
        this.production.average = Math.round(100 * this.city.yield.average * this.dcPower * (this.efficiency / 100) * (this.modules[0].performanceOverYears[0] / 100)) / 100;
        for (a = 0; a < this.modules[0].performanceOverYears.length; a++) {
            this.production.years[a] = Math.round(100 * this.city.yield.average * (this.dcPower * this.efficiency / 100) * (this.modules[0].performanceOverYears[a] / 100) * 12) / 100;
        }
        this.calcNewAverageBilling(this.site)

        return true;
    }
    getTransformer(power, transformers){
        for (var a = 0; a< transformers.length ; a++){
            var t= Object.assign({},  transformers[a]);
            if(t.power> power)
                return t;            
        }
        return {}
    }
    getTransformers( power, transformers, vin,allowCombinations ){
        var transformersAdd = [];

        if(transformers.length == 0)
            return {};
        var maxPower = transformers[transformers.length-1].power;
        var acPowerAdd = power;
        var t = {};
        var n = Math.floor(power/maxPower);
        //var allowCombinations  =true;
        if(allowCombinations){
            if(n>0){
                t = Object.assign({},transformers[transformers.length-1])
                t.quantity = n;
                transformersAdd.push(t);
                acPowerAdd -=  n*maxPower;
            }
        }
       
        if(acPowerAdd >0){
            t =  this.getTransformer(acPowerAdd ,transformers )
            if(t.id){
                var item = transformersAdd.find(
                    (element) => element.id == t.id 
                );
                    
                if (item)
                    item.quantity++
                else{
                    t.quantity =1;
                    transformersAdd.push(t);
    
                }
            }else{
                this.messages.push("Adicionar transformador de "  + acPowerAdd + " kW, " + vin + "V/" + this.acVoltage +"V" )
            }
        }       
        return transformersAdd;

    }
    calcAccessories(requestComponents, stringboxes , cables, connectors,transformers){
        this.messages = [];
       if(requestComponents.transformer){
            var filterTransformers = transformers.filter(el => el.vout == this.acVoltage);
            var i = 0; 
            var inverter = {};
            var acPowerArray = [
                            {vin:220,power:0 },
                            {vin:380,power:0 },
                            {vin:440,power:0 },                   
            ]    
            for (  i = 0; i< this.inverters.length; i++){
                inverter = this.inverters[i];
                if((inverter.acVoltage !== this.acVoltage )&&(this.phases == 3)){
                    var p =  acPowerArray.find(
                        (element) => element.vin == inverter.acVoltage 
                    );
                    p.power += inverter.acPower * inverter.quantity;
                }   
            }
            
            for (var x = 0; x< acPowerArray.length ; x++){
                var filterTransformers2 =  filterTransformers.filter(el => el.vin == acPowerArray[x].vin);
                var transformersAdd =   this.getTransformers(acPowerArray[x].power, filterTransformers2,acPowerArray[x].vin, true );
                if(transformersAdd.length>0){
                    this.transformers = this.transformers.concat(transformersAdd)
                }
            }
        }

        if(requestComponents.stringbox){
            for (  i = 0; i< this.inverters.length; i++){
                
                inverter = this.inverters[i];
                var s ={};

                if(inverter.acPower<6)
                    s = this.getStringbox(stringboxes,2,1);
                if((inverter.acPower>=6)&&(inverter.acPower < 20))
                    s = this.getStringbox(stringboxes,4,2);
                if((inverter.acPower>=20)&&(inverter.acPower <= 33))
                    s = this.getStringbox(stringboxes,6,2);
                if((inverter.acPower>33)&&(inverter.acPower <= 40))
                    s = this.getStringbox(stringboxes,10,1);
                if((inverter.acPower>40)&&(inverter.acPower < 50))
                    s = this.getStringbox(stringboxes,12,1);
                if(inverter.acPower>50)
                    s = this.getStringbox(stringboxes,14,2);
                if(s){
                    s.quantity = inverter.quantity;
                    this.stringboxes.push(s);

                }
                else    
                    this.messages.push("stringbox não encontrado para inversor: " + inverter.code  )
                    
            }
        }
        
        
        
        var a = 0 ; 

        console.log(JSON.stringify(cables))
        for (a = 0; a< cables.length; a++){
            var cable = Object.assign({}, cables[a])
            cable.quantity =this.getCableQuantity(this.dcPower);
            this.cables.push(cable);
        }



        console.log(JSON.stringify(connectors))
        for (a = 0; a< connectors.length; a++){
            var connector = Object.assign({}, connectors[a])
            connector.quantity =this.getConnectorQuantity(this.dcPower);
            this.connectors.push(connector);
        }
       // console.log("calcAccessories, nInputs:" + nInputs + ", nOutpus:" + nOutputs )
        
        //for (var )
    };

    getCableQuantity(dcPower) {
        var i = Math.floor(dcPower * 1.1065 + 35.593);
        return i;
    };
    getConnectorQuantity(dcPower) {
        var a = dcPower * 0.3068 + 6.656;
        var i = a / 2.0;
        return Math.floor(i) * 2;
    };
    getStringbox(stringboxes, nInputs, nOutpus){
        console.log("getStringbox")
        for (var s = 0; s< stringboxes.length;s++){
            if((stringboxes[s].nInputs >= nInputs) &&( stringboxes[s].nOutputs>= nOutpus)){
                return stringboxes[s];
            }
        }
        return false;
    }

    calcStructure(structure) {
        console.log("calcStructure")
        this.mountings = [];
        this.structure = Object.assign({},structure);

        console.log(JSON.stringify(this.generators));
        console.log(JSON.stringify(this.structure));
        


        var m;
        if (this.modules.length>0){
            //alert("with modules")
            //alert(JSON.stringify(this.modules[0]));
            //m = new Mounting(this.modules[0],this.structure ,"portrait" );
            m = new Mounting( );
            m.module = this.modules[0];
            m.nModules =  this.modules[0].quantity;
        }
        if(this.generators.length>0){
            //alert("with generators")
            //alert(JSON.stringify(this.generators[0].modules[0]));
            //m = new Mounting(this.generators[0].modules[0],this.structure ,"portrait" )
            m = new Mounting();
            m.module =this.generators[0].modules[0];
            m.nModules =  this.generators[0].modules[0].quantity;
        }
        m.quantity = 1;         
        m.structure = this.structure;
        m.structureId= this.structure.id;
        this.mountings.push(m);
        this.recalcStructure();
    }
    concatArray(myArray, arrayAdd){
        for (var a = 0;a <arrayAdd.length; a++){
            var item = Object.assign({}, arrayAdd[a]);
            var found = false;
            for (var b = 0; b< myArray.length ; b++){
               if(item.code == myArray[b].code){
                   myArray[b].quantity += item.quantity;
                   found =true;
               } 
            }
            if(!found){
                myArray.push(item);
            }
        }   
        return myArray;
    };
    recalcGenerator(nModules){  
        if(nModules<=0){
            nModules = 1;
        }

       // alert("recalcGenerator")
       // alert(JSON.stringify(this.generators))
        if(this.generators.length>0){
            var generator = this.generators[0];
            var dcPowerEstimated = nModules *  generator.modules[0].dcPower;
            var cost = this.generatorEstimation(dcPowerEstimated, this.availableDevices.generators);
            
            generator.modules[0].quantity = nModules;
            generator.dcPower = dcPowerEstimated;
           
            generator.product.cost = cost;
            generator.code = `KIT-${globalFunctions.formatDecimal(generator.dcPower,3)}-KWP`
            generator.description = `Kit fotovoltaico ${globalFunctions.formatDecimal(generator.dcPower,3)} kWp.`

            this.dcPower = dcPowerEstimated;
            this.nModules = nModules;

        }
    };

    generatorEstimation(dcPower, generators) {
        var dcPowerArr = [0];
        var costArr = [0];
        for (var g = 0; g < generators.length; g++) {
            var generator = generators[g];
            dcPowerArr.push(generator.dcPower);
            costArr.push(generator.product.cost);
        }
        var found = false;
        var a = dcPowerArr.length - 1;
        var foundIndex = -1;
        while ((!found) && (a >= 0)) {
            if (dcPower > dcPowerArr[a]) {
                foundIndex = a;
                found = true;
            }
            a--;
        };
        if (foundIndex >= (dcPowerArr.length - 1))
            foundIndex = dcPowerArr.length - 2;
        var a = (costArr[foundIndex + 1] - costArr[foundIndex]) / (dcPowerArr[foundIndex + 1] - dcPowerArr[foundIndex]);
        var b = costArr[foundIndex] - (a * dcPowerArr[foundIndex]);
        var cost = dcPower * a + b;
        return cost
    };


   recalcStructure() {
       this.rails =[];
       this.accessories = [];
        // for (var m =0 ; m < this.mountings.length ; m++){
        //         //Check rails
        //         this.rails = this.mountings[m].rails;
        //         this.accessories = this.mountings[m].accessories;

        //     }

       this.area = 0;
       for(var m =0; m < this.mountings.length ; m++){

                this.mountings[m].calc();
                this.rails = this.concatArray( this.rails,  this.mountings[m].rails);
                this.accessories = this.concatArray(this.accessories, this.mountings[m].accessories ) ;            
                this.area += this.mountings[m].area
            }
 
        //console.log(JSON.stringify(this.structure));
        //Calc acessories
        // var  a =0;
        // var quantity = 0;
        // var accessory = {};
        // for(a= 0; a<this.structure.accessories.length;a++){
        //     accessory = this.structure.accessories[a];
        //     console.log("add accessory>"+ JSON.stringify(accessory));
        //     console.log("this.nModules>"+ JSON.stringify(this.nModules));
        //     quantity =accessory.quantity * Math.ceil(this.nModules/accessory.parameter); 
        //     accessory.device.quantity= quantity;
        //     this.accessories.push(accessory.device);
        // }
        //   <md-option value=0>Módulo(s)</md-option>
        //         <md-option value=1>Espaço(s) intermediário(s)</md-option>
        //         <md-option value=2>Espaço(s) final(finais)</md-option>
        //         <md-option value=3>Fileira(s)</md-option>
    }
}

export default SolarPlant;

